export default [
  {
    type: 'home',
    formItems: [
      {
        label: "页面名称",
        name: "title",
        key: "params",
        type: "text",
        stamp: 'input',
        defaultValue: '产品溯源',
      },
      {
        label: "客服电话",
        name: "phone",
        key: "params",
        type: "text",
        stamp: 'input',
      },
      {
        label: "身高管理跳转链接",
        name: "sglink",
        key: "params",
        type: "text",
        stamp: 'input',
      },
      {
        label: "防伪认证模板",
        name: "antis_fake_tem_title",
        key: "params",
        type: "text",
        stamp: 'query',
      },
      {
        label: "弹窗视频链接",
        name: "video_url",
        key: "params",
        type: "text",
        help:"视频库中的视频可粘贴链接到输入框内",
        stamp: 'input',
      },
      {
        label: "视频封面",
        name: "icon",
        key: "style",
        stamp: 'singleImage',
        help: "建议视频尺寸大小与视频封面一致",
      },
    ]
    
  },
  {
    type: 'standard',
    formItems: [ 
      {
        label: "背景颜色",
        name: "backgroundColor",
        key: "style",
        type: "color",
        stamp: 'input',
        defaultValue: '#abdeff',
      },
      {
        label: "图片",
        type: "image",
        key: "data",
        stamp: 'image',
      },
    ]
  },
  {
    type: 'ly',
    formItems: [
      {
        label: "背景颜色",
        name: "backgroundColor",
        key: "style",
        type: "color",
        stamp: 'input',
        defaultValue: '#F8F8F8',
      },
      {
        label: "文字颜色",
        name: "textColor",
        key: "style",
        type: "color",
        stamp: 'input',
        defaultValue: '#2182CA',
      },
    
      {
        label: "背景图",
        name: "icon",
        key: "style",
        stamp: 'singleImage',
        help: "建议尺寸750*658，大小500Kb以内",
        defaultValue: '/web_base_assets/scan/customer_10000010/map.png',
      },
      {
        label: "基础人数",
        name: "number",
        key: "params",
        type: "text",
        stamp: 'input',
        help:"用于消费者页面显示消费者页面显示基础人数+所在省份扫码人数"
      },
    ]
  },
  {
    type: 'pzjk',
    formItems: [
      {
        label: "图片",
        type: "image",
        key: "data",
        stamp: 'image',
      },
    ]
  }
]